import { Flex } from "@minervaproject/fds";

import { ActiveBreakout } from "./active_breakout";
import { NonActiveBreakout } from "./non_active_breakout";

import { useAppSelector } from "hooks/redux_hooks";
import { classroomSelectors } from "store";

function Breakouts() {
  const activeBreakoutSessionId = useAppSelector(
    classroomSelectors.selectActiveBreakoutSessionId(),
  );
  return (
    <Flex className="sidebar-width">
      <Flex auto className="vertical-scroll" direction="column" p={2}>
        {activeBreakoutSessionId ? (
          <ActiveBreakout breakoutSessionId={activeBreakoutSessionId} />
        ) : (
          <NonActiveBreakout />
        )}
      </Flex>
    </Flex>
  );
}

export { Breakouts };
